import { render } from "./OneCTrips.vue?vue&type=template&id=5cdad2a9&scoped=true&ts=true"
import script from "./OneCTrips.vue?vue&type=script&lang=ts"
export * from "./OneCTrips.vue?vue&type=script&lang=ts"

import "./OneCTrips.vue?vue&type=style&index=0&id=5cdad2a9&lang=scss&scoped=true"

import exportComponent from "/builds/spark/services/frontend/admin-v2/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5cdad2a9"]])

export default __exports__